/** Utility functions for dealing with the participants of
 * a GetOffersRequest. This is necessary, because there is a high
 * impedance mismatch between what a UI would like to display / edit
 * (e.g. simple passenger counts) versus the data in the object
 * (List of participants, each categorized by age group)
 */

import { List, Map } from 'immutable'


const increment = (n = 0) => n + 1

/** List<Participant::Map> -> Map<AgeGroup,Number> 
 * with a special 'total' key added for total count.
 * AgeGroup name is always lowercased. */
export const countByAgeGroup = (participants = List()) =>
    participants.reduce( (totals, participant) => 
        totals.update('total', increment)
            .update(
                participant.get('ageClassification','').toLowerCase(), increment)
        , Map())


/** Produces a new participants list with a participant of the
 * given ageGroup added. */
export const addParticipantWithAgeGroup = ageGroup => (participants = List()) =>
    participants.push(Map.of('ageClassification', ageGroup))


/** Produces a new participants list with one participant of the
 * given ageGroup removed. */    
export const remParticipantWithAgeGroup = (ageGroup = '') => (participants = List()) => {
    const idx = participants.findIndex( p => 
        p.get('ageClassification','').toLowerCase() === ageGroup.toLowerCase() )
    return idx >= 0
        ? participants.remove(idx)
        : participants
}



// WEBPACK FOOTER //
// ./src/ndc/request/participants-utils.js